import { useCallback, useEffect, useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router";
import { isTokenExist } from "utils/cookies";
import store from "store";
import PublicLayout from "../public";
import ChangeEnvModal from "components/apps/ChangeEnvModal";
import usePreviousPathname from "hooks/usePreviousPathName";

const initialEnvState = { count: 0, open: false };

const Login = () => {
  const [envModal, setEnvModal] = useState(initialEnvState);
  const from = usePreviousPathname();

  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    // Halaman undangan TIDAK di-redirect walau sudah login: halaman itu sendiri
    // yang meminta logout dulu. Kalau di-redirect, undangan tidak pernah diproses
    // dan user malah masuk ke akun yang sedang login di tab lain.
    if (pathname.startsWith("/user/invite")) return;
    if (isTokenExist()) {
      if (store.get("app.endpoint") && from) {
        navigate(from, {
          replace: true,
        });
      }
    }
  }, [navigate, from, pathname]);

  const clickFooterHandler = useCallback(() => {
    setEnvModal((prevState) => {
      const countClick = prevState.count + 1;
      return { count: countClick, open: countClick > 10 };
    });
  }, []);

  const cancelEnvModalHandler = useCallback(() => {
    setEnvModal(initialEnvState);
  }, []);

  return (
    <PublicLayout
      onClickFooter={clickFooterHandler}
      className="min-h-screen bg-blue-900"
    >
      <Outlet />
      {envModal.open && (
        <ChangeEnvModal open={envModal.open} onCancel={cancelEnvModalHandler} />
      )}
    </PublicLayout>
  );
};

export default Login;
